import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from './security/guard/auth.guard';
import { HttpService } from './http/http.service';
import { HttpAuthService } from './security/http-auth.service';
import { JwtWrapperService } from './security/jwt-wrapper.service';
import { AuthTokenStorageService } from './security/auth-token-storage.service';
import { LocalStorageService } from './local-storage/local-storage.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestInterceptor } from './http/request-interceptor';
import { configurationFactory, ConfigurationService } from './configuration/configuration.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { UserService } from './user/user.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    HttpService,
    HttpAuthService,
    AuthGuard,
    UserService,
    LocalStorageService,
    AuthTokenStorageService,
    ConfirmationService,
    MessageService,
    JwtWrapperService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: configurationFactory,
      multi: true,
      deps: [ConfigurationService],
    },
  ],
})
export class CoreModule {
  public static forRoot(): ModuleWithProviders<CoreModule> {
    return { ngModule: CoreModule };
  }
}
